export class OrchestratorTotemRequest {
    public idTotemButton: number | null = null;

    public idPatient: number | null = null;

    public idUserPatient: number | null = null;

    public listPriority: number[] = [];

    public listTotemPriority: number[] = [];

    public birthDate: Date | null = null;

    public isSchedule: boolean = false;

    public idSchedule: number | null = null;

    sendSmsForUpdateAddress: boolean = false;

}